module.exports = __webpack_public_path__ + "assets/img/ic-dark-close0d0583ce.svg";